var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallMountedElectricalJunctionBox01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.06,14.17H2.94V4.06h10.13V14.17z M3.44,13.67h9.13V4.56H3.44V13.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 1.4,
    className: "st2",
    width: 0.5,
    height: 2.91
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.76,9.89L7.2,9.83c0.01,0.29,0.07,0.48,0.16,0.59c0.1,0.11,0.23,0.16,0.4,0.16c0.12,0,0.23-0.03,0.32-0.09 c0.09-0.06,0.15-0.13,0.19-0.23S8.32,10,8.32,9.79V7.21h0.5v2.55c0,0.31-0.04,0.56-0.11,0.73c-0.08,0.17-0.2,0.3-0.36,0.39 c-0.16,0.09-0.36,0.13-0.58,0.13c-0.33,0-0.58-0.09-0.75-0.28S6.75,10.26,6.76,9.89z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallMountedElectricalJunctionBox01);
export default __webpack_public_path__ + "static/media/WallMountedElectricalJunctionBox-01.175c7248e03c383aa2547ad1dd57f1ab.svg";
export { ForwardRef as ReactComponent };